export function CrossIcon() {
  return (
    <svg width="9" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.98391 3.03793L7.31298 0.000270245L8.04011 0.731546L4.90577 3.64215L8.20377 6.6805L7.43796 7.4532L4.22007 4.54329L0.891011 7.58095L0.164569 6.84899L3.29683 3.93908L0.000221787 0.900727L0.766024 0.128019L3.98391 3.03793Z"
        fill="currentColor"
      />
    </svg>
  );
}
